module.exports = { "default": require("core-js/library/fn/reflect/construct"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/construct.js
// module id = pQ2V
// module chunks = 1